module.exports = __webpack_public_path__ + "img/compact.7a999c8d.png";